// Import the generated introspection schema
import schemaData from './schema.json'

export const schema = schemaData
